import PhoneIcon from '../../../../../ui/svg/common/phone';
import EmailIcon from '../../../../../ui/svg/common/email';
import React from 'react';

const CartDesktopHeader = () => {
    return (
        <div className="hidden md:flex items-center mb-4">
            <h1 className="text-5xl font-bold flex-1">Shopping Cart</h1>

            <ul className="flex font-bold text-gray-700">
                <li className="ml-6 flex items-center">
                    <PhoneIcon width="15px" color="#1D1D1D" />
                    <span className="ml-2">Need Help?</span>
                </li>
                <li className="ml-6">Call +1-865-909-9200 ext. 2</li>
                <li className="ml-6 flex items-center inapp-hidden">
                    <EmailIcon width="17px" color="#1D1D1D" />
                    <a href="/contact-sales" title="" className="ml-2 no-underline text-gray-700">Email Us</a>
                </li>
            </ul>
        </div>
    )
};

export default CartDesktopHeader;